import { POSTRequest } from "../apiHandler";
import { FormSelectOptionsInterface } from "../Form/interfaces";

type ILoadOptionsActions = 'warehouse'|'storage_type'|'storage_bin'|'item'|'project'|'requester'|'lot_items'|'transaction'
export const loadOptions = (a:ILoadOptionsActions, tag:string|string[], otherData :any = {}) => 
new Promise<FormSelectOptionsInterface[]>((resolve, reject) => {
  POSTRequest("select.php",a,{tag, ...otherData}).then(response => resolve(response))
})